import { inject, Injectable } from '@angular/core';
import { API_URLS, WebServiceProvider } from '@pinnakl/core/web-services';
import { Workspace } from '@pinnakl/crm/domain';
import { getErrorMessage } from '@pinnakl/shared/util-helpers';
import { PinnaklUIToastMessage } from '@pinnakl/shared/util-providers';

@Injectable({
  providedIn: 'root',
})
export class CrmWorkspacesApiService {
  private readonly apiUrls = inject(API_URLS);
  private readonly wsp = inject(WebServiceProvider);
  private readonly toast = inject(PinnaklUIToastMessage);

  async load(): Promise<Workspace[]> {
    try {
      return await this.wsp.get<Workspace[]>({
        endpoint: this.apiUrls.crmWorkspaces,
      });
    } catch (error) {
      this.toast.error('Unable to load workspaces. ' + getErrorMessage('', error));
      throw error;
    }
  }
}
